
import XHeader from 'vux/src/components/x-header/index.vue'

import { mapState } from 'vuex'

export default {
name: 'Header',
components: { XHeader },
props: {
pageTitle: {
required: false
},
showFilter: {
required: false,
type: Boolean,
default: false
},
zIndex: {}
},
data () {
return {
}
},
computed: {
...mapState({
route: state => state.route,
isHeaderArea: state => state.route.meta.isHeaderArea
}),
leftVisible () {
if (this.pageTitle) return true
return !this.route.meta.isTabBar
},
title () {
if (this.pageTitle) return this.pageTitle
if (this.route.meta.title) return this.$t(this.route.meta.title)
return ''
},
headerVisible () {
if (this.pageTitle) return true
return this.isHeaderArea
}
},
methods: {
}
}



// WEBPACK FOOTER //
// ./src/components/Header/Header.vue